import { BehaviorSubject } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { IExistData } from '../model/merge-exist-data.interface';
import { LocalRepository } from '@shared/helper/local-repository';
import { EMergeType, IMergeItem as IMergeItem } from '../model/merge-item.interface';
import { BaseComponent } from '@shared/components/base/base.component';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';

export const MERGE_AUTHOR_LIST = 'merge_author_list'
export const MERGE_PUBLISHER_LIST = 'merge_publisher_list'
export const MERGE_BOOK_LIST = 'merge_book_list'

@Injectable({
  providedIn: 'root'
})
export class MergeService extends BaseComponent {
  private _localRepository = inject(LocalRepository);



  private MergeAuthorsList: IMergeItem[] = [];
  private MergePublishersList: IMergeItem[] = [];
  private MergeBooksList: IMergeItem[] = [];

  selectedAuthorToMerge: BehaviorSubject<IMergeItem[]>;
  selectedPublisherToMerge: BehaviorSubject<IMergeItem[]>;
  selectedBookToMerge: BehaviorSubject<IMergeItem[]>;

  constructor() {
    super()
    this.MergeAuthorsList = this.GetAuthorsMergeList || [];
    this.MergePublishersList = this.GetPublisherMergeList || [];
    this.MergeBooksList = this.GetBookMergeList || [];

    this.selectedAuthorToMerge = new BehaviorSubject<IMergeItem[]>(this.MergeAuthorsList);
    this.selectedPublisherToMerge = new BehaviorSubject<IMergeItem[]>(this.MergePublishersList);
    this.selectedBookToMerge = new BehaviorSubject<IMergeItem[]>(this.MergeBooksList)
  }


  public get GetAuthorsMergeList(): IMergeItem[] {
    if (this._localRepository.IsInBrowser)
      return JSON.parse(this._localRepository.getLocalItem(MERGE_AUTHOR_LIST)!);
    else return [];

  }

  public get GetPublisherMergeList(): IMergeItem[] {
    if (this._localRepository.IsInBrowser)
      return JSON.parse(this._localRepository.getLocalItem(MERGE_PUBLISHER_LIST)!);
    else return [];
  }

  public get GetBookMergeList(): IMergeItem[] {
    if (this._localRepository.IsInBrowser) {
      return JSON.parse(this._localRepository.getLocalItem(MERGE_BOOK_LIST)!);
    }
    return [];
  }

  public SetMergeList(value: IMergeItem) {
    switch (value.type) {
      case EMergeType.author:
        const MergeListLength = this.MergeAuthorsList?.length;
        if (MergeListLength < 2) {
          const ExistCheck = this.IsExist(value.id, value.type);
          if (!ExistCheck.isExist) {
            this.MergeAuthorsList.push(value);
            this.selectedAuthorToMerge.next(this.MergeAuthorsList);
            this._localRepository.setLocalItem(MERGE_AUTHOR_LIST, JSON.stringify(this.MergeAuthorsList));
          }
        }
        else
          this.snackbarService.openSnackbar(
            SnackBarTypes.warning,
            'تلفیق همزمان بیش از دو نویسنده ممکن نیست');
        break;

      case EMergeType.publisher:
        const MergePublisherListLength = this.MergePublishersList?.length;
        if (MergePublisherListLength < 2) {
          const ExistCheck = this.IsExist(value.id, value.type);
          if (!ExistCheck.isExist) {
            this.MergePublishersList.push(value);
            this.selectedPublisherToMerge.next(this.MergePublishersList);
            this._localRepository.setLocalItem(MERGE_PUBLISHER_LIST, JSON.stringify(this.MergePublishersList));
          }
        }
        else
          this.snackbarService.openSnackbar(
            SnackBarTypes.warning,
            'تلفیق همزمان بیش از دو ناشر ممکن نیست'
          );
        break;

      case EMergeType.book:
        const MergeBookListLength = this.MergeBooksList?.length;
        if (MergeBookListLength < 2) {
          const ExistCheck = this.IsExist(value.id, value.type);
          if (!ExistCheck.isExist) {
            this.MergeBooksList.push(value);
            this.selectedBookToMerge.next(this.MergeBooksList);
            this._localRepository.setLocalItem(MERGE_BOOK_LIST, JSON.stringify(this.MergeBooksList));
          }
        }
        else {
          this.snackbarService.openSnackbar(SnackBarTypes.warning, 'تلفیق همزمان بیش از دو کتاب ممکن نیست.' );
        }
        break;
    }
  }

  public RemoveMergeItem(itemId: string, itemType: EMergeType) {
    try {
      const ExistCheck = this.IsExist(itemId, itemType);
      if (ExistCheck.isExist) {
        if (itemType === EMergeType.author) {
          this.MergeAuthorsList.splice(ExistCheck.existIndex, 1);
          this.selectedAuthorToMerge.next(this.MergeAuthorsList);
          this._localRepository.setLocalItem(MERGE_AUTHOR_LIST, JSON.stringify(this.MergeAuthorsList));
        }
        else if (itemType === EMergeType.publisher) {
          this.MergePublishersList.splice(ExistCheck.existIndex, 1);
          this.selectedPublisherToMerge.next(this.MergePublishersList);
          this._localRepository.setLocalItem(MERGE_PUBLISHER_LIST, JSON.stringify(this.MergePublishersList));
        }
        else if (itemType === EMergeType.book) {
          this.MergeBooksList.splice(ExistCheck.existIndex, 1);
          this.selectedBookToMerge.next(this.MergeBooksList);
          this._localRepository.setLocalItem(MERGE_BOOK_LIST, JSON.stringify(this.MergeBooksList));
        }
      }
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public ClearAllMerge() {
    this._localRepository.removeLocalItem(MERGE_AUTHOR_LIST);
    this.selectedAuthorToMerge.next([]);
    this._localRepository.removeLocalItem(MERGE_PUBLISHER_LIST);
    this.selectedPublisherToMerge.next([]);
    this._localRepository.removeLocalItem(MERGE_BOOK_LIST);
    this.selectedBookToMerge.next([]);
  }

  public IsExist(itemId: string, itemType: EMergeType): IExistData {
    if (itemType === EMergeType.author) {
      const FoundedIndex = this.MergeAuthorsList.findIndex(item => item.id === itemId);
      const result: IExistData = {
        isExist: (FoundedIndex === -1 ? false : true),
        existIndex: FoundedIndex
      };
      return result;
    }

    else if (itemType === EMergeType.publisher) {
      const FoundedIndex = this.MergePublishersList.findIndex(item => item.id === itemId);
      const result: IExistData = {
        isExist: (FoundedIndex === -1 ? false : true),
        existIndex: FoundedIndex
      };
      return result;
    }

    else if (itemType === EMergeType.book) {
      const FoundedIndex = this.MergeBooksList.findIndex(item => item.id === itemId);
      const result: IExistData = {
        isExist: (FoundedIndex === -1 ? false : true),
        existIndex: FoundedIndex
      };
      return result;
    }

    return {} as IExistData;
  }

  public AllowedToInsert(item: IMergeItem) {
    let result = false;
    if (this.MergeAuthorsList?.length == 0 && this.MergePublishersList?.length == 0 && this.MergeBooksList?.length == 0) {
      result = true
    }
    else if (this.MergeAuthorsList?.length > 0 && item.type === EMergeType.author) {
      result = true;
    }
    else if (this.MergePublishersList?.length > 0 && item.type === EMergeType.publisher && this.MergeBooksList?.length == 0) {
      result = true;
    }
    else if (this.MergeBooksList?.length > 0 && item.type === EMergeType.book && this.MergePublishersList?.length == 0 && this.MergeAuthorsList?.length == 0) {
      result = true;
    }

    return result;
  }
}


